import { render, staticRenderFns } from "./historicalLongRatio.vue?vue&type=template&id=48ab7de3"
import script from "./historicalLongRatio.vue?vue&type=script&lang=js"
export * from "./historicalLongRatio.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/home/historicalLongRatio.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/home/historicalLongRatio.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports